import { permissionsForRole, ROLE_LABELS, ROLES, type Role } from '@nexo/core';
import { Icon } from '../components/Icon';
import { useSession } from '../lib/session';

// Columnas curadas: los permisos que más dicen sobre lo que un rol puede agor.
const KEY_PERMS: Array<{ code: string; label: string }> = [
  { code: 'document.create', label: 'Crear' },
  { code: 'document.issue_fiscal', label: 'Facturar' },
  { code: 'document.correct', label: 'Rectificar' },
  { code: 'document.approve', label: 'Aprobar' },
  { code: 'payment.register', label: 'Cobros' },
  { code: 'kyc.approve', label: 'KYC' },
  { code: 'ai.apply', label: 'Aplicar IA' },
  { code: 'audit.view', label: 'Audit' },
];

export function Users() {
  const { me } = useSession();
  const currentRole = me?.role;

  return (
    <main className="main main--wide">
      <div className="page-head">
        <div className="page-head__title">
          <span className="eyebrow">Administration</span>
          <h1 className="h1">Usuarios y roles</h1>
          <p className="page-head__sub">What each role can do. This matrix comes from the same engine that authorizes every action on the server, so it reflects exactly what applies.</p>
        </div>
      </div>

      {me && (
        <div className="card" style={{ marginBottom: 18 }}>
          <div className="card__body" style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span className="user-chip__avatar" style={{ width: 40, height: 40, fontSize: 15 }}>
              {me.user.name.split(' ').slice(0, 2).map((w) => w[0]).join('')}
            </span>
            <div>
              <div style={{ fontWeight: 600 }}>{me.user.name}</div>
              <div className="faint" style={{ fontSize: 13 }}>Tu rol actual: <b style={{ color: 'var(--accent)' }}>{me.roleLabel}</b></div>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card__head"><span className="card__title">Matriz de roles y permisos</span></div>
        <div className="card__body" style={{ overflowX: 'auto' }}>
          <table className="lines" style={{ minWidth: 720 }}>
            <thead>
              <tr>
                <th style={{ minWidth: 180 }}>Rol</th>
                {KEY_PERMS.map((p) => <th key={p.code} className="r" style={{ width: 78 }}>{p.label}</th>)}
                <th className="r">Total</th>
              </tr>
            </thead>
            <tbody>
              {ROLES.map((role) => {
                const perms = permissionsForRole(role as Role);
                const isCurrent = role === currentRole;
                return (
                  <tr key={role} style={isCurrent ? { background: 'var(--accent-tint)' } : undefined}>
                    <td>
                      <span className="lines__desc" style={{ color: isCurrent ? 'var(--accent-deep)' : undefined }}>
                        {ROLE_LABELS[role as Role]}
                      </span>
                      {isCurrent && <span className="type-tag" style={{ marginLeft: 8 }}>You</span>}
                    </td>
                    {KEY_PERMS.map((p) => {
                      const has = perms.includes(p.code as never);
                      return (
                        <td key={p.code} className="r">
                          {has ? (
                            <Icon name="check" size={15} className="tone-active" style={{ display: 'inline-block' }} />
                          ) : (
                            <span className="faint">·</span>
                          )}
                        </td>
                      );
                    })}
                    <td className="r num" style={{ fontWeight: 600 }}>{perms.length}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
}
